import { ComponentProps } from 'react';
import classNames from 'classnames';
import { Skeleton } from '@mui/material';
import { ButtonTheme, ButtonVariant } from './Button';
import './Button.scss';

interface SkeletonCompactButtonProps {
    className?: string;
    startIcon?: React.ReactNode;
    endIcon?: React.ReactNode;
    theme?: ButtonTheme;
    variant?: ButtonVariant;
}

export function SkeletonButton({
    className,
    startIcon,
    endIcon,
    variant = 'contained',
    theme = 'skeleton',
    ...skeletonProps
}: SkeletonCompactButtonProps & Omit<ComponentProps<typeof Skeleton>, 'variant'>) {
    return (
        <div
            className={classNames(
                className,
                'Button',
                'Button--disabled',
                `Button--${variant}`,
                `Button--${theme}`,
            )}
            data-testid="SkeletonCompactButton"
        >
            {startIcon && <div className="Button__icon">{startIcon}</div>}
            <div className="Button__text">
                <Skeleton height={22} width={80} {...skeletonProps} variant="text" />
            </div>
            {endIcon && <div className="Button__icon">{endIcon}</div>}
        </div>
    );
}
